import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";

const Login = () => {
  const { enqueueSnackbar } = useSnackbar();

  //1.--> set the state and events to keep track of the login data

  const [formData, setFormData] = useState({
    username: "", 
    password: "",
  })


  //5--> set the loader icon during post API
const [isLoggIn, setLogIn] = useState(false)

  const handleChange=(e)=>{
    const [key,value] = [e.target.name, e.target.value];
    setFormData((newFormData)=>({...newFormData, [key]:value}))
    // console.log(key, value)
  }


  //6--> implementing useHistory when registration is successfull add it to event handler

const history= useHistory();

const loginSuccess=()=>{
  history.push("/")
}




  // TODO: CRIO_TASK_MODULE_LOGIN - Fetch the API response
  /**
   * Perform the Login API call
   * @param {{ username: string, password: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/login"
   *
   * Example for successful response from backend:
   * HTTP 201
   * {
   *      "success": true,
   *      "token": "testtoken",
   *      "username": "criodo",
   *      "balance": 5000
   * }
   *
   * Example for failed response from backend:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Password is incorrect"
   * }
   *
   */

   //2--> make the post request for sending the data to the backend; 
   //3--> use the event handler to the login buttoon 
  const login = async (formData) => {
    // console.log(formData)
    let message;
    
    setLogIn(true)

    try{
      const response = await axios.post(config.endpoint + '/auth/login', {
        username: formData.username,
        password: formData.password,
      })
      setLogIn(false)
      // console.log(response)
      //-> getting username, token & balance of the user to save it in localStorage
      const username= response.data.username;
      const token = response.data.token;
      const balance= response.data.balance;

      //4--> for 200 status show success message and for 400 show backend message and other errors as backend probs.
      if(response.status===201){
        message='Logged in successfully';
        enqueueSnackbar(message,{
          variant:'success',
          autoHideDuration: 3000
        })
        //--> adding the token , username & balance to localStorage when the api response got success
        persistLogin(token, username, balance)
        //8--> when login success go to products page
        loginSuccess()


      }

    }catch(err){
      setLogIn(false)
      if(err.response.status===400){
        message=err.response.data.message
        return enqueueSnackbar(message,{
          variant:'error',
          autoHideDuration: 3000
        })
      }else{
        message=message='Something went wrong. Check that the backend is running, reachable and returns valid JSON.'
        return enqueueSnackbar(message,{
          variant:'error',
          autoHideDuration: 3000
        })
      }
      
    }

  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Validate the input
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false and show warning message if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that password field is not an empty value - "Password is a required field"
   */


   //5-> validate input
  const validateInput = (data) => {
    let message;
    if(data.username.length === 0){
      message= 'Username is a required field';
      return enqueueSnackbar(message,{
        variant:'warning',
        autoHideDuration: 3000
      })
    }else if(data.password.length ===0){
      message= 'Password is a required field';
      return enqueueSnackbar(message,{
        variant:'warning',
        autoHideDuration: 3000
      })
    }else{
      return login(data)
    }
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Persist user's login information
  /**
   * Store the login information so that it can be used to identify the user in subsequent API calls
   *
   * @param {string} token
   *    API token used for authentication of requests after logging in
   * @param {string} username
   *    Username of the logged in user
   * @param {string} balance
   *    Wallet balance amount of the logged in user
   *
   * Make use of localStorage: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
   * -    `token` field in localStorage can be used to store the Oauth token
   * -    `username` field in localStorage can be used to store the username that the user is logged in as
   * -    `balance` field in localStorage can be used to store the balance amount in the user's wallet
   */
  const persistLogin = (token, username, balance) => {

    // console.log('token:'token +' name:' username +' balance :' balance )
    localStorage.setItem("token", token);
    localStorage.setItem("username", username)
    localStorage.setItem("balance", balance)
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons= {true} />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className='title'>Login</h2>
          < TextField 
          id='username' 
          name='username' 
          label='username' 
          variant='outlined'
          value={formData.username}
          onChange={handleChange}
           fullWidth />
          < TextField 
          id='password'
          name="password"
          type="password" 
           label='Password' 
           variant='outlined' 
           value={formData.password}
           onChange={handleChange}
           fullWidth />


           { //-->6 implement loader icon logic using conditonal rendering
             isLoggIn ? <CircularProgress /> :
             <Button  variant="contained" onClick={()=>{validateInput(formData)}}>LOGIN TO QKART</Button>
           }
          
          <p>Don’t have an account?
          <Link to="/register" className='link'>Register now</Link>
            
            </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Login;
